import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Button from '@mui/material/Button';

export default function InputImage({ chip_label, text_label, button_text }) {
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      gap: "1rem",
      marginBottom: "1.5rem"
    }}>
      <Chip
        label={chip_label}
        color='secondary'
        sx={{
          background: "gray",
          width: "5rem",
          color: "white",
          height: "40px",
          display: "flex",
          alignItems: "center"
        }}
      />
      {/*  */}

      {chip_label === "Browse" ?
        <Button
          style={{ color: "lightgray" }}
          variant="outlined"
          component="label"
          sx={{
            width: '20vw',
            '& label': {
              color: 'lightgray',
            },
            '& label.Mui-focused': {
              color: 'gray',
            },
            '& .MuiInputBase-input': {
              color: 'lightgray',
            },
            '&.MuiButton-outlined': {
              borderColor: 'lightgray',
              '&:hover': {
                borderColor: 'gray',
                backgroundColor: 'transparent',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'gray',
              },
            },
            height: "40px",
            margin: "0 2rem",
          }}
        >
          {text_label}
          <input
            type="file"
            hidden
          />
        </Button>


        : <TextField
          label={text_label}
          size="small"
          variant="outlined"
          sx={{
            width: '20vw',
            '& label': {
              color: 'lightgray',
            },
            '& label.Mui-focused': {
              color: 'gray',
            },
            '& .MuiInputBase-input': {
              color: 'lightgray',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'lightgray',
              },
              '&:hover fieldset': {
                borderColor: 'gray',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'gray',
              },
            },
            height: "40px",
            margin: "0 2rem"
          }}
        />
      }

      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={button_text === "download" ? <CloudDownloadIcon /> : <CloudUploadIcon />}
        sx={{
          width: "12rem",
          backgroundColor: 'transparent',
          border: "1px solid gray",
          color: 'white',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          height: "40px",
          display: "flex",
          alignItems: "center"
        }}
      >
        {button_text}
      </Button>
    </div>
  );
}